module.exports = __webpack_public_path__ + "img/btn-save-en.f398a0da.png";